import React, { Component } from 'react'
import { withReactTrack } from '@du/analytics-sdk'

import styles from './index.module.less'

interface IProductItemProps {
  index: any
  spuId: any
  title: string
  itemNo: any
  cover: any
  price: any
  handleCover: any
  handlePrice: any
  getCurrency: any
  goDetail: any
  getRef?: any
  globalConfig?: any
  pageId?: any
}

class ProductItem extends Component<IProductItemProps> {
  render() {
    const {
      index,
      // 以上为埋点接口
      spuId,
      title,
      itemNo,
      cover,
      price,
      handleCover,
      handlePrice,
      getCurrency,
      goDetail,
      getRef,
    } = this.props
    return (
      <div
        ref={getRef}
        className={styles.item}
        key={spuId}
        data-index={index}
        onClick={() => goDetail({ spuId, index, title }, itemNo)}
      >
        <div className={styles['cover-box']}>
          <img className={styles.cover} data-layzload-src={handleCover(cover)} alt="" />
        </div>
        <div className={styles['spu-title']}>{title}</div>
        <div className={styles.info}>
          <div className={styles.price}>
            {getCurrency()}&nbsp;{handlePrice(price)}
          </div>
        </div>
      </div>
    )
  }
}

export default ProductItem
